module.exports = __webpack_public_path__ + "static/media/female_death.be2f022b.mp3";